import type { AxiosRequestConfig } from "axios";
import qs from "qs";
import { axiosInstance } from "../../axios-instance";
import { qsOptions } from "../qsOptions";
import type { R } from "../types";
import type {
  IDeleteContractorRequest,
  IDeleteContractorResponse,
  IGetContractingCompaniesResponse,
  IGetContractorProfileByUserIdRequest,
  IGetContractorProfileByUserIdResponse,
  IGetContractorsRequest,
  IGetContractorsResponse,
  IUpdateContractorProfessionalDetailsRequest,
  IUpdateContractorProfessionalDetailsResponse,
  IUpdateContractorRequest,
  IUpdateContractorResponse,
  IUpdateContractorServiceAreasRequest,
  IUpdateContractorServiceAreasResponse,
} from "./types";

export class ContractorsService {
  async getAll(
    p: IGetContractorsRequest,
    c?: AxiosRequestConfig,
  ): R<IGetContractorsResponse> {
    try {
      const params = qs.stringify(p, qsOptions);
      return axiosInstance.get(`/api/contractor/all?${params}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getContractingCompanies(
    c?: AxiosRequestConfig,
  ): R<IGetContractingCompaniesResponse> {
    try {
      return axiosInstance.get(`/api/contractingCompany/all`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async deleteContractor(
    p: IDeleteContractorRequest,
    c?: AxiosRequestConfig,
  ): R<IDeleteContractorResponse> {
    try {
      return axiosInstance.delete(`/api/contractor/${p.userId}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async updateProfile(
    p: IUpdateContractorRequest,
    c?: AxiosRequestConfig,
  ): R<IUpdateContractorResponse> {
    try {
      return axiosInstance.put(`/api/contractor/updateContractor`, p, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async updateContractorServiceArea(
    p: IUpdateContractorServiceAreasRequest,
    c?: AxiosRequestConfig,
  ): R<IUpdateContractorServiceAreasResponse> {
    try {
      return axiosInstance.put(
        `/api/contractor/updateServiceArea/${p.userId}`,
        p.serviceAreas,
        c,
      );
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getProfileByUserId(
    p: IGetContractorProfileByUserIdRequest,
    c?: AxiosRequestConfig,
  ): R<IGetContractorProfileByUserIdResponse> {
    try {
      return axiosInstance.get(`/api/contractor/user/${p.userId}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async updateContractorProfessionalDetails(
    p: IUpdateContractorProfessionalDetailsRequest,
    c?: AxiosRequestConfig,
  ): R<IUpdateContractorProfessionalDetailsResponse> {
    try {
      const params = qs.stringify(p, qsOptions);
      return axiosInstance.put(
        `/api/contractor/updateContractorProfessionalDetails?${params}`,
        p,
        c,
      );
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
